import HistoryTime from 'components/HistoryTime';
import { getText } from 'i18n/intl';
import _ from 'lodash';
import type { TFieldRelation } from '@timeedit/types/lib/types';
import { TEDrawerSection, TEInput } from '@timeedit/ui-components';
import './FieldRelationInfo.scss';

interface FieldRelationInfoProps {
  fieldRelation: TFieldRelation;
  onChange: (key: string, value: any) => void;
}
const FieldRelationInfo = (props: FieldRelationInfoProps) => {
  const { fieldRelation, onChange } = props;

  return (
    <div className="field-relation-info">
      <TEDrawerSection label="General info">
        <div className="wrapper-content">
          <TEInput.Input
            label="Name"
            tooltip="Name"
            value={fieldRelation.name}
            onChange={(val) => onChange('name', val)}
            placeholder={getText('new_field_relation')}
            data-testid="relation-name"
          />
          <TEInput.PureText
            label="Id"
            tooltip="Id"
            value={`${fieldRelation.id}`}
          />

          <HistoryTime history={fieldRelation?.history} />
        </div>
      </TEDrawerSection>
    </div>
  );
};

export default FieldRelationInfo;
